module.exports = __webpack_public_path__ + "bcdc808513341e041e205f578a0887dd.svg";